// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-link-active[data-v-0598f2bc]{--tw-text-opacity:1;color:rgba(0, 122, 204, var(--tw-text-opacity))}.dark .nuxt-link-active[data-v-0598f2bc]{--tw-text-opacity:1;color:rgba(90, 189, 255, var(--tw-text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
